var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpoloipo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248.2,
    height: 158.7,
    viewBox: "0 0 248.2 158.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 187.2,
    height: 157.9,
    transform: "translate(156.8 197.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17947",
    "data-name": "Path 17947",
    d: "M282.3,250.6s-16.2,5.6-21.2,29.9c0,0,11,6.1,21.9,7.4C283,287.8,298.1,248.2,282.3,250.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17954",
    "data-name": "Path 17954",
    d: "M331.7,325.2s-3.5.7-8.8,1.4c-.2,0-.4.1-.6.1H321c-2.4.3-5.1.6-7.9.9-3.5.4-7.2.6-10.9.8a104.583,104.583,0,0,1-11.2,0c-.5,0-1.1-.1-1.6-.1-1.5-.1-3-.2-4.4-.4-18.1-2.5-19-4.6-19-4.6a45.368,45.368,0,0,0,4.7-12.4,51.206,51.206,0,0,0,.8-15.9c-.1-1.6-1.2-14.6-1.1-18.2,0-.6.1-1.1.1-1.7a21.272,21.272,0,0,1,.8-3.8c2.6-8,5.6-17.8,10.8-21a37.754,37.754,0,0,1,4.8-2.5c.8-.3,1.7-.7,2.6-1h.1a34.862,34.862,0,0,1,3.8-1,33.562,33.562,0,0,1,11.9-.3c.7.1,1.4.2,2.3.4h.1a26.291,26.291,0,0,1,10.9,6.2,18.3,18.3,0,0,1,4.3,7.5c2.8,8,3,18.2,3.1,19.6A265.3,265.3,0,0,0,331.7,325.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17985",
    "data-name": "Path 17985",
    d: "M162.4,270.8l14.8,34.5c.1.2.2.3.4.3H231c.3,0,.5-.4.3-.8l-16.6-34.5c-.1-.2-.2-.2-.3-.2H162.8C162.5,270,162.3,270.4,162.4,270.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17991",
    "data-name": "Path 17991",
    d: "M287.3,279.2s18.8-29.2,26.2-27.9,10.6,6.5,10.6,12.6-9.5,34.4-9.5,34.4S296.2,292.6,287.3,279.2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "homepage_govpay-09",
    "data-name": "homepage govpay-09",
    transform: "translate(-101.4 -197.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17933",
    "data-name": "Path 17933",
    d: "M349.2,356.2H101.8a.4.4,0,1,1,0-.8H349.2a.43.43,0,0,1,.4.4A.366.366,0,0,1,349.2,356.2Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17934",
    "data-name": "Path 17934",
    d: "M172.9,262.4a8.58,8.58,0,0,0-6.6-2.5H127.1a4.565,4.565,0,0,1-4.8-4.8V212.3a4.619,4.619,0,0,1,4.8-4.8h61.5a4.565,4.565,0,0,1,4.8,4.8v58.6c0,4.8-5.2,6-8.3,2.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17935",
    "data-name": "Path 17935",
    d: "M189.1,276a6.139,6.139,0,0,1-4.5-2.1l-12.2-11.1h0a8,8,0,0,0-6.2-2.3H127a5.175,5.175,0,0,1-5.4-5.3V212.4a5.175,5.175,0,0,1,5.4-5.3h61.5a5.175,5.175,0,0,1,5.4,5.3V271a4.8,4.8,0,0,1-3,4.8A11.019,11.019,0,0,1,189.1,276Zm-15.8-14,12.2,11.1a4.532,4.532,0,0,0,5.1,1.5,3.807,3.807,0,0,0,2.3-3.7V212.3a4.069,4.069,0,0,0-4.3-4.2H127a4.069,4.069,0,0,0-4.3,4.2v42.8a4.069,4.069,0,0,0,4.3,4.2h39.2C168.2,259.4,171.1,259.6,173.3,262Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17936",
    "data-name": "Path 17936",
    d: "M132.7,212h50.6a3.691,3.691,0,0,1,3.7,3.7v36.6a3.691,3.691,0,0,1-3.7,3.7H132.7a3.691,3.691,0,0,1-3.7-3.7V215.7A3.757,3.757,0,0,1,132.7,212Z",
    fill: "#D2D369"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 38,
    height: 0.8,
    transform: "translate(138.9 215.8)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 38,
    height: 0.8,
    transform: "translate(138.9 243.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 15.8,
    height: 1,
    transform: "translate(138.9 222.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 13.7,
    height: 1,
    transform: "translate(138.9 225.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 13.7,
    height: 1,
    transform: "translate(138.9 237.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 8.1,
    height: 1,
    transform: "translate(168.7 237.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 17.5,
    height: 1,
    transform: "translate(138.9 228.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 11.4,
    height: 1,
    transform: "translate(138.9 231.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 16.2,
    height: 1,
    transform: "translate(138.9 234.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 7.1,
    height: 1,
    transform: "translate(169.1 222.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 4.2,
    height: 1,
    transform: "translate(170.6 225.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 13.7,
    height: 1,
    transform: "translate(138.9 249)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 4.2,
    height: 1,
    transform: "translate(170.6 249.1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 7.9,
    height: 1,
    transform: "translate(168.7 228.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 3.3,
    height: 1,
    transform: "translate(171 231.4)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 5.6,
    height: 1,
    transform: "translate(169.9 234.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17937",
    "data-name": "Path 17937",
    d: "M182,256.4H134.1a5.763,5.763,0,0,1-5.7-5.7V232a.6.6,0,0,1,1.2,0v18.8a4.588,4.588,0,0,0,4.6,4.6H182a.645.645,0,0,1,.6.6C182.6,256.2,182.3,256.4,182,256.4Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17938",
    "data-name": "Path 17938",
    d: "M187.1,244a.645.645,0,0,1-.6-.6V216.6a4.588,4.588,0,0,0-4.6-4.6H134a.6.6,0,1,1,0-1.2h48a5.763,5.763,0,0,1,5.7,5.7v26.8C187.7,243.8,187.5,244,187.1,244Z",
    fill: "#060e12"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "woman_2_00000118383168314841787720000007407247454941365439_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "woman_1_00000029011869659209674450000008108957930045722012_",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17939",
    "data-name": "Path 17939",
    d: "M209.5,303c-1.9,1.2-14.9,9.5-18.9,7-.6-.4-1.9-1.2-2-2.6v-.2a2.854,2.854,0,0,1,.9-1.9h0c.2-.2.4-.3.5-.4a7.6,7.6,0,0,1-1.6.9h0a3.78,3.78,0,0,1-2.7.4c-1.3-.5-1.7-2.3-1.8-2.5a4.662,4.662,0,0,1,2.3-4.6.774.774,0,0,0-.3.1c-.2,0-.4.1-.6.1-1.1.1-2.7.1-3.4-.9s-.1-2.5.1-3.1c1.4-3.6,7.8-7.7,16.5-9.6a49.842,49.842,0,0,1,24.9,1.3C240.8,313,209.5,303,209.5,303Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17940",
    "data-name": "Path 17940",
    d: "M190.4,310.3c-.6-.4-2.1-1.4-2.2-3V307a1.884,1.884,0,0,1,.2-.8,4.746,4.746,0,0,1-2.8.3c-1.6-.6-2-2.6-2.1-2.8a4.615,4.615,0,0,1,1.2-4,3.708,3.708,0,0,1-3.2-1.2c-.8-1.2-.2-2.9.1-3.5,1.6-4,8.5-8.1,16.8-9.9a50.162,50.162,0,0,1,25.1,1.3c.1,0,.2.1.3.2,5.1,7.6,6.6,13,4.3,16-3.8,5.1-16.6,1.4-18.6.8-3.9,2.5-12.2,7.4-16.9,7.4A3.156,3.156,0,0,1,190.4,310.3Zm19.2-7.8c.1,0,14.1,4.4,17.7-.4,2-2.6.5-7.6-4.2-14.8a48.567,48.567,0,0,0-24.4-1.3c-9.3,2-14.9,6.3-16.1,9.3-.2.5-.7,1.8-.2,2.6.6.8,2.1.8,3,.7.2,0,.5-.1.6-.1a.367.367,0,0,0,.3-.1.713.713,0,0,1,.6.3.481.481,0,0,1-.2.6,4.105,4.105,0,0,0-2.1,4.1s.3,1.7,1.4,2.1a3.2,3.2,0,0,0,2.4-.4h0a13.234,13.234,0,0,0,1.5-.8.5.5,0,0,1,.6.8l-.4.4a2.718,2.718,0,0,0-.8,1.6v.2a3.317,3.317,0,0,0,1.7,2.2c2.8,1.8,11.6-2.6,18.3-7a.367.367,0,0,1,.3-.1C209.5,302.5,209.6,302.5,209.6,302.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17941",
    "data-name": "Path 17941",
    d: "M219.7,298.9c-2.7-.9-3.5.4-9.6,1.4-5.1.8-7.4.4-8.6,2.3a4.137,4.137,0,0,0-.5,3c1.8,4.9,20.1,3.3,22.7-1a2.451,2.451,0,0,0,.4-1.5C224.1,301.1,221.6,299.5,219.7,298.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17942",
    "data-name": "Path 17942",
    d: "M207.4,308.9c-2.7-.2-6-1-6.8-3.2a4.178,4.178,0,0,1,.6-3.5c1-1.5,2.6-1.7,5.3-2a30.573,30.573,0,0,0,3.6-.5c2.3-.4,3.8-.8,5-1.1,1.9-.5,3-.8,4.7-.2,1.6.5,4.7,2.2,4.8,4.6a3.884,3.884,0,0,1-.5,1.8c-1.6,2.6-8.3,4.2-14.2,4.2A10.477,10.477,0,0,1,207.4,308.9Zm7.9-9.3a38.238,38.238,0,0,1-5.1,1.1c-1.4.2-2.6.4-3.7.5-2.5.3-3.8.4-4.6,1.6a3.545,3.545,0,0,0-.5,2.6c.5,1.3,2.7,2.3,6,2.6,6.4.6,14.4-1.2,15.9-3.7a2.352,2.352,0,0,0,.4-1.2c-.1-1.5-2.2-3-4.2-3.7h0a4.935,4.935,0,0,0-1.5-.3A11.186,11.186,0,0,0,215.3,299.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17943",
    "data-name": "Path 17943",
    d: "M284.6,251.1s-16.4,10.3-18.5,23.3c-2.2,13-3.5,24-3.5,24l12.6,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17944",
    "data-name": "Path 17944",
    d: "M275.1,300.9l-12.6-2c-.3,0-.4-.3-.4-.5,0-.1,1.3-11.2,3.5-24.1,2.2-13.1,18.1-23.2,18.8-23.6a.446.446,0,0,1,.5,0c.2.1.2.3.2.5l-9.4,49.3a.675.675,0,0,1-.6.4Zm-8.6-26.4c-1.9,11.4-3.1,21.3-3.4,23.6l11.6,1.8,9.1-47.7C280.4,254.6,268.3,263.6,266.5,274.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1687",
    "data-name": "Group 1687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17945",
    "data-name": "Path 17945",
    d: "M282.3,250.6s-16.2,5.6-21.2,29.9c0,0,11,6.1,21.9,7.4C283,287.8,298.1,248.2,282.3,250.6Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17946",
    "data-name": "Path 17946",
    d: "M282.3,250.6s-16.2,5.6-21.2,29.9c0,0,11,6.1,21.9,7.4C283,287.8,298.1,248.2,282.3,250.6Z",
    fill: "#61703f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 33,
    height: 81,
    transform: "translate(258 248)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABRCAYAAABcxs+uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAuElEQVRoge3awQ2CQBBG4V/rsgpLsDBLsAr7wnh4ZlwuHMDZxPcdCYmPHQMbwimD+/WyjMduj+fqvD1tijhCvbC2iOr86x8cvVekPSIzrESMKIyAEZgvouOWvYroYgSMgBEwAq0R7LhdCRgBI2AEjMAnomuTG8dRGAEjYAT+O6K+VnYcMAJGwAjME9G5v4zjKIyAETACRqAlYvwoxHHACBgBIzBHRPcmN46jMAK7fme59U/+9ShP8gKQ9B7KK1EPAgAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1685",
    "data-name": "Group 1685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17948",
    "data-name": "Path 17948",
    d: "M282.3,250.6s-16.2,5.6-21.2,29.9c0,0,11,6.1,21.9,7.4C283,287.8,298.1,248.2,282.3,250.6Z",
    fill: "#61703f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1688",
    "data-name": "Group 1688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17949",
    "data-name": "Path 17949",
    d: "M275.2,300.4c-.6,2.1-2.7,3.8-6.3,5a25.152,25.152,0,0,1-2.5.8c-5.9,1.2-40-1.5-42.5-1.7,2-4.2,2.5-5.8,2.3-6.2,0,0-.3-1.2-.4-1.4,0-.1,0-.2-.1-.2v-.1c0-.1,0-.2-.1-.2l-.3-.9c0-.1,0-.2-.1-.2,0-.1-.1-.2-.1-.3s-.1-.2-.1-.4c-.1-.2-.1-.5-.2-.7,0-.1,0-.1-.1-.2,0-.1-.1-.2-.1-.3v-.2h0v-.6c-.6-1.9-1.1-3.8-1.7-5.7,13.8-.5,27.7-1,41.5-1.5a50.3,50.3,0,0,1,7.7,6.9C274.7,295.5,275.8,298.2,275.2,300.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17950",
    "data-name": "Path 17950",
    d: "M223.8,305a.52.52,0,0,1-.4-.2.3.3,0,0,1,0-.4c2.3-4.8,2.3-5.7,2.3-5.9,0,0-.3-1.2-.4-1.4l-.1-.2.5-.2-.5.1v-.1l-1-3.3h0l-.1-.3.5-.1-.5.1v-.2h0l-1.7-5.7a.6.6,0,0,1,.1-.4.52.52,0,0,1,.4-.2l41.5-1.5a.367.367,0,0,1,.3.1,57.061,57.061,0,0,1,7.8,7c2.8,3.3,3.9,6.1,3.3,8.5h0q-.9,3.45-6.6,5.4c-.1,0-1.3.5-2.6.8a37.552,37.552,0,0,1-5.7.3C249.3,307,226.8,305.2,223.8,305Zm-.4-17.6,1.5,5.1-.5.2.5-.1v.2l.1.3v.1l1.1,3.7c.1.2.4,1.4.4,1.4.1.5,0,1.6-2.1,5.9,5.2.4,36.2,2.7,41.7,1.6a19.393,19.393,0,0,0,2.5-.7c3.4-1.2,5.4-2.8,6-4.7h0c.6-2-.5-4.6-3.1-7.6a52.756,52.756,0,0,0-7.5-6.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1691",
    "data-name": "Group 1691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1690",
    "data-name": "Group 1690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17951",
    "data-name": "Path 17951",
    d: "M263.6,439.7c.4,17.8.8,43.7.6,75.7,9.8.4,19.7.8,29.5,1.2q3.15-156.3,5.2-156.2,2.1,0,3,156.8c10.3-.6,20.5-1.2,30.8-1.7-1.4-82.5-.9-116.8,0-131.8a230.629,230.629,0,0,0-1-46.9c-.1-1.1-.3-2.1-.4-3.1l-1.1-8.5-63.9-2.6c-.2,2.3-.5,4.9-.8,7.7-.8,8.5-1.7,19.6-2.3,32.3C261.9,392,262.9,411.7,263.6,439.7Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1693",
    "data-name": "Group 1693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17952",
    "data-name": "Path 17952",
    d: "M331.7,325.2s-3.5.7-8.8,1.4c-.2,0-.4.1-.6.1H321c-2.4.3-5.1.6-7.9.9-3.5.4-7.2.6-10.9.8a104.583,104.583,0,0,1-11.2,0c-.5,0-1.1-.1-1.6-.1-1.5-.1-3-.2-4.4-.4-18.1-2.5-19-4.6-19-4.6a45.368,45.368,0,0,0,4.7-12.4,51.206,51.206,0,0,0,.8-15.9c-.1-1.6-1.2-14.6-1.1-18.2,0-.6.1-1.1.1-1.7a21.272,21.272,0,0,1,.8-3.8c2.6-8,5.6-17.8,10.8-21a37.754,37.754,0,0,1,4.8-2.5c.8-.3,1.7-.7,2.6-1h.1a34.862,34.862,0,0,1,3.8-1,33.562,33.562,0,0,1,11.9-.3c.7.1,1.4.2,2.3.4h.1a26.291,26.291,0,0,1,10.9,6.2,18.3,18.3,0,0,1,4.3,7.5c2.8,8,3,18.2,3.1,19.6A265.3,265.3,0,0,0,331.7,325.2Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17953",
    "data-name": "Path 17953",
    d: "M331.7,325.2s-3.5.7-8.8,1.4c-.2,0-.4.1-.6.1H321c-2.4.3-5.1.6-7.9.9-3.5.4-7.2.6-10.9.8a104.583,104.583,0,0,1-11.2,0c-.5,0-1.1-.1-1.6-.1-1.5-.1-3-.2-4.4-.4-18.1-2.5-19-4.6-19-4.6a45.368,45.368,0,0,0,4.7-12.4,51.206,51.206,0,0,0,.8-15.9c-.1-1.6-1.2-14.6-1.1-18.2,0-.6.1-1.1.1-1.7a21.272,21.272,0,0,1,.8-3.8c2.6-8,5.6-17.8,10.8-21a37.754,37.754,0,0,1,4.8-2.5c.8-.3,1.7-.7,2.6-1h.1a34.862,34.862,0,0,1,3.8-1,33.562,33.562,0,0,1,11.9-.3c.7.1,1.4.2,2.3.4h.1a26.291,26.291,0,0,1,10.9,6.2,18.3,18.3,0,0,1,4.3,7.5c2.8,8,3,18.2,3.1,19.6A265.3,265.3,0,0,0,331.7,325.2Z",
    fill: "#61703f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1694",
    "data-name": "Group 1694",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 71,
    height: 88,
    transform: "translate(265 243)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABYCAYAAACnMOpRAAAACXBIWXMAAAsSAAALEgHS3X78AAABIUlEQVR4nO3cQWrCUBRA0ei6ugqX4MK6BFfRfbVUsJivXrAYDOGcYcjEyxskD/N30+Dz8PE9Xrs4nr5u7t+yp+IsYc3B3x5nCa8Kvsk4r7Lfxs9YhjhBnCBOECeIE8QJ4gRxgjhBnAd+38/ECeIEcYI4QZwgTpjFsQWcMzlBnCBOECeIE8QJ4gRxgjhBnCBOECeIE8S54/LnJ3GCOEGcIE4QJ4gT/uJYrt8yOUGcIE4QJ4gTxAniBHGCOEGcIE4QJ4gTxBlcf1ksThAniBPECeKEcxz74/tMThAniBPECeIEcYI4QZwgThAniBPECeIEca6MJ1OKE8QJ4gRxgjhBnLC3XH/M5ISnj+Pe8qSND4FvPxx+TbFXF2cJ/w0+izNN0w8OzSrVIfkrowAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17955",
    "data-name": "Path 17955",
    d: "M331.7,325.2s-3.5.7-8.8,1.4c-.2,0-.4.1-.6.1H321c-2.4.3-5.1.6-7.9.9-3.5.4-7.2.6-10.9.8a104.583,104.583,0,0,1-11.2,0c-.5,0-1.1-.1-1.6-.1-1.5-.1-3-.2-4.4-.4-18.1-2.5-19-4.6-19-4.6a45.368,45.368,0,0,0,4.7-12.4,51.206,51.206,0,0,0,.8-15.9c-.1-1.6-1.2-14.6-1.1-18.2,0-.6.1-1.1.1-1.7a21.272,21.272,0,0,1,.8-3.8c2.6-8,5.6-17.8,10.8-21a37.754,37.754,0,0,1,4.8-2.5c.8-.3,1.7-.7,2.6-1h.1a34.862,34.862,0,0,1,3.8-1,33.562,33.562,0,0,1,11.9-.3c.7.1,1.4.2,2.3.4h.1a26.291,26.291,0,0,1,10.9,6.2,18.3,18.3,0,0,1,4.3,7.5c2.8,8,3,18.2,3.1,19.6A265.3,265.3,0,0,0,331.7,325.2Z",
    fill: "#61703f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17956",
    "data-name": "Path 17956",
    d: "M326.6,210.5a.762.762,0,0,0-1.4-.6c-.1.1-.1.2-.1.4l-14.9,12.1.5.7L325.6,211A1.231,1.231,0,0,0,326.6,210.5Z",
    fill: "#f86e6d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17957",
    "data-name": "Path 17957",
    d: "M320.6,226.7l-.7,1.1-2.7-11.1.7-.6Z",
    fill: "#f86e6d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17958",
    "data-name": "Path 17958",
    d: "M286.1,220.2a12.066,12.066,0,0,1,.5-4.7,12.742,12.742,0,0,1,2.2-4.1,13.071,13.071,0,0,1,4.5-4.1,12.232,12.232,0,0,1,3.2-1.1c4.1-.8,11.5,1.6,15.3,7.8a16.653,16.653,0,0,1-.1,17.6c-3.1,4.6-9.1,7.3-10.8,6a3.659,3.659,0,0,1-1.1-3.2,1.421,1.421,0,0,1,.2-.6c1.9-4.8,4.1-5.7,4-7.2C303.9,224.8,300.3,222.4,286.1,220.2Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17959",
    "data-name": "Path 17959",
    d: "M282.3,250.8a.367.367,0,0,0,.3-.1c2.1-1.3,4.7-2.4,4.7-2.5a27.731,27.731,0,0,1,2.6-1h.1c1.2-.4,2.5-.7,3.7-1a32.828,32.828,0,0,1,11.7-.3c.7.1,1.4.2,2.3.4h.1a24.124,24.124,0,0,1,6.3,2.8.515.515,0,1,0,.5-.9,26.074,26.074,0,0,0-6.6-2.9h-.1c-.9-.2-1.7-.3-2.3-.4a34.519,34.519,0,0,0-12,.3c-1.3.3-2.6.6-3.8,1h-.1a27.731,27.731,0,0,0-2.6,1,30.506,30.506,0,0,0-4.9,2.5.574.574,0,0,0-.2.7C282,250.8,282.1,250.8,282.3,250.8Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17960",
    "data-name": "Path 17960",
    d: "M289.7,246.9h0c.9-.3,1.8-.5,2.8-.8V226h10.4v19.3c.8.1,1.7.2,2.6.3.7.1,1.4.2,2.3.4a19.975,19.975,0,0,1-5.7,6.4,14.371,14.371,0,0,1-3.3,1.9,17.245,17.245,0,0,1-6.9,1.3,8.426,8.426,0,0,1-2.4-3.8A7.247,7.247,0,0,1,289.7,246.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17961",
    "data-name": "Path 17961",
    d: "M291.8,256.1a.367.367,0,0,1-.3-.1,8.114,8.114,0,0,1-2.5-4,9.76,9.76,0,0,1,.2-5.3.451.451,0,0,1,.3-.3h.1c.7-.2,1.5-.4,2.3-.7V226a.472.472,0,0,1,.5-.5h10.4a.472.472,0,0,1,.5.5v18.8a15.172,15.172,0,0,1,2.1.3c.7.1,1.4.2,2.4.4a.319.319,0,0,1,.3.3.3.3,0,0,1,0,.4,23,23,0,0,1-5.8,6.6,17.815,17.815,0,0,1-3.4,2,16.063,16.063,0,0,1-6.5,1.3Zm13.5-10c-.8-.1-1.6-.2-2.5-.3-.3,0-.4-.2-.4-.5V226.5H293v19.6a.664.664,0,0,1-.4.5c-1,.2-1.8.5-2.5.7a7.312,7.312,0,0,0-.1,4.5,7.638,7.638,0,0,0,2.1,3.4,14.284,14.284,0,0,0,6.5-1.3,15.614,15.614,0,0,0,3.2-1.9,18.981,18.981,0,0,0,5.2-5.7C306.4,246.2,305.9,246.2,305.3,246.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17962",
    "data-name": "Path 17962",
    d: "M283.5,225.4a7.808,7.808,0,0,1,1.3-3c.5-.9.9-1.3,1.2-1.8,1.6-2.3,2.6-5.3,3.9-7.4a1.456,1.456,0,0,1,.9-.8c3.8,2.9,6.1,4.5,7.6,5.5a16.3,16.3,0,0,1,4.3,3.6c.6.8.8,1.3,1.2,1.8a1.594,1.594,0,0,1,.4,1.2,2.223,2.223,0,0,1,1.8,0,2.86,2.86,0,0,1,1,2.8,4.144,4.144,0,0,1-2.3,2.7,9.107,9.107,0,0,1-2.7,1.1c-.1.3-.3.6-.4.9-1,2.2-1.6,3.3-2.5,4-1.4,1.1-2.8,1.3-5.6,1.6a21.822,21.822,0,0,1-4.5.3,6.376,6.376,0,0,1-3.4-1.1,5.221,5.221,0,0,1-1.4-2c-.9-2-.5-3-1-7.7A4.415,4.415,0,0,0,283.5,225.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17963",
    "data-name": "Path 17963",
    d: "M289.3,238.4a6.736,6.736,0,0,1-3.6-1.2,5.763,5.763,0,0,1-1.5-2.2,10.19,10.19,0,0,1-.8-4,34.375,34.375,0,0,0-.3-3.9,4.817,4.817,0,0,1,0-1.7,9.461,9.461,0,0,1,1.3-3.2,12.827,12.827,0,0,1,1-1.5c.1-.1.2-.3.3-.4a26.7,26.7,0,0,0,2.2-4.1c.6-1.2,1.1-2.3,1.7-3.3a2.056,2.056,0,0,1,1.3-1,.6.6,0,0,1,.4.1c3.6,2.7,5.9,4.4,7.6,5.4l.1.1a18.615,18.615,0,0,1,4.3,3.6c.4.5.6.8.8,1.1a1.538,1.538,0,0,0,.4.6,1.934,1.934,0,0,1,.5.9,2.464,2.464,0,0,1,1.7.2c1.1.6,1.4,2.1,1.3,3.3a4.522,4.522,0,0,1-2.5,3,8.486,8.486,0,0,1-2.6,1.1l-.3.7c-1,2.2-1.6,3.3-2.6,4.2-1.5,1.2-3.1,1.4-5.9,1.7-1.9.2-3,.3-3.9.3A2.042,2.042,0,0,1,289.3,238.4ZM304.6,225c-.1.1-.3,0-.4-.1a.52.52,0,0,1-.2-.4,1.222,1.222,0,0,0-.3-.9,3.508,3.508,0,0,1-.5-.8c-.2-.3-.4-.6-.7-1a14.857,14.857,0,0,0-4-3.4l-.1-.1c-1.7-1-4-2.7-7.5-5.3a.887.887,0,0,0-.4.5,31.029,31.029,0,0,0-1.7,3.2,34.251,34.251,0,0,1-2.3,4.2c-.1.1-.2.3-.3.4-.3.4-.5.8-.9,1.4a7.07,7.07,0,0,0-1.2,2.8h0a7.444,7.444,0,0,0,0,1.5c.2,1.8.2,3,.3,4a7.983,7.983,0,0,0,.7,3.6,4.353,4.353,0,0,0,1.3,1.8,5.648,5.648,0,0,0,3.1,1,20.424,20.424,0,0,0,4.4-.3c2.8-.3,4.1-.5,5.4-1.5.8-.7,1.3-1.7,2.3-3.8l.4-.9.3-.3a6.913,6.913,0,0,0,2.5-1,4.119,4.119,0,0,0,2.1-2.4,2.392,2.392,0,0,0-.8-2.3,1.268,1.268,0,0,0-.6-.1A2.92,2.92,0,0,0,304.6,225Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17964",
    "data-name": "Path 17964",
    d: "M296.7,224.1c-.1.3-.8.4-1.6.3-.8-.2-1.4-.6-1.3-.9s.8-.4,1.6-.3C296.2,223.4,296.8,223.8,296.7,224.1Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17965",
    "data-name": "Path 17965",
    d: "M287.5,220.2c-.2.3.2.9.8,1.4.7.5,1.4.6,1.5.4.2-.3-.2-.9-.8-1.4C288.4,220,287.7,219.9,287.5,220.2Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17966",
    "data-name": "Path 17966",
    d: "M310.7,215c.2-.4,6.2-8.7,11.4-3,5.1,5.7.1,13.7-9.2,10.2S310.7,215,310.7,215Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17967",
    "data-name": "Path 17967",
    d: "M317.5,214.7a10.909,10.909,0,0,1-.6,1.1l-1.7-6.6h0a.762.762,0,1,1,1-.4c0,.1-.1.1-.1.2Z",
    fill: "#f86e6d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17968",
    "data-name": "Path 17968",
    d: "M296.1,329.2c2,0,4,0,6.2-.1,3.4-.2,7.1-.4,10.9-.8,2.6-.3,5.3-.6,8-.9h.3l1.6-.2c5.2-.7,8.8-1.4,8.8-1.4.1,0,.2-.1.3-.2s.1-.2.1-.4c-1.1-5.2-2-10.4-2.8-15.4,0-.3-.3-.4-.6-.4s-.4.3-.4.6q1.2,7.35,2.7,15c-1.1.2-4.2.7-8.3,1.3l-1.5.2h-.3c-2.6.4-5.3.7-7.9.9-3.8.4-7.5.7-10.9.8a102.444,102.444,0,0,1-11.1,0c-.5,0-1.1-.1-1.6-.1-1.5-.1-3-.3-4.3-.4-14.3-2-17.7-3.7-18.4-4.2a46.063,46.063,0,0,0,4.5-12.2,52.776,52.776,0,0,0,.8-16.1l-.1-.9c-.3-3.5-1.2-14.1-1-17.3,0-.6.1-1.1.1-1.7a17.874,17.874,0,0,1,.8-3.7c.8-2.4,1.6-4.9,2.4-7.3a.474.474,0,0,0-.9-.3c-.9,2.5-1.7,5-2.4,7.4a20.767,20.767,0,0,0-.9,3.9,9.149,9.149,0,0,0-.1,1.7c-.1,3.3.7,13.9,1,17.4l.1.9a54.075,54.075,0,0,1-.8,15.8,45.711,45.711,0,0,1-4.6,12.3.3.3,0,0,0,0,.4c.2.4,1.9,2.6,19.3,4.9,1.4.2,2.8.3,4.4.4.5,0,1.1.1,1.6.1C292.6,329.1,294.3,329.2,296.1,329.2Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17969",
    "data-name": "Path 17969",
    d: "M228.9,276.5l-.3-.3c.4-.4,9.7-9,16.6-8.7v.4C238.5,267.6,229,276.5,228.9,276.5Z",
    fill: "#b68089"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1727",
    "data-name": "Group 1727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17970",
    "data-name": "Path 17970",
    d: "M260,282.8a21.654,21.654,0,0,1-6,13.7l-.3-.3a19.961,19.961,0,0,0,2.6-25.2,2.507,2.507,0,0,1,.7.4A20.184,20.184,0,0,1,260,282.8Z",
    fill: "#b68089"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1729",
    "data-name": "Group 1729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1728",
    "data-name": "Group 1728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17971",
    "data-name": "Path 17971",
    d: "M243.6,268c-5.1,0-18.4.4-19.2,4.1a3.141,3.141,0,0,0,.3,2.2c1,1.5,3.5,1.4,5.8,1.4a16.011,16.011,0,0,0,5.1-.7A15.758,15.758,0,0,0,243.6,268Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17972",
    "data-name": "Path 17972",
    d: "M224.3,274.5a3.673,3.673,0,0,1-.4-2.5c.8-3.6,11.2-4.4,19.7-4.5h0a.52.52,0,0,1,.4.2.446.446,0,0,1,0,.5,15.212,15.212,0,0,1-8.2,7.1,14.631,14.631,0,0,1-5.3.7h-1.4C227.1,276.1,225.2,275.8,224.3,274.5Zm.6-2.4a2.726,2.726,0,0,0,.3,1.8c.8,1.3,3.2,1.2,5.4,1.1a15.431,15.431,0,0,0,5-.7,14.274,14.274,0,0,0,7.2-5.9C232.1,268.6,225.4,270,224.9,272.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17973",
    "data-name": "Path 17973",
    d: "M226.7,278.6c2.4-2.6,4.4-4.8,7.7-6.7,3.4-2,9.6-5.7,16.3-3.5h0c.1,0,.2.1.3.1a15.443,15.443,0,0,1,3.4,1.7c.6.3,1.3.6,1.9.9a2.507,2.507,0,0,1,.7.4c1.5.7,3,1.5,4.6,2.2,1.3.6,2.6,1.2,3.8,1.9,7.5,3.6,15,7.3,22.6,10.9,3.4-6.4,18.8-35.2,27.5-32.7,2.3.7,4.2,3.5,4.3,3.7,3.3,4.9,1.5,11.4,0,16-7.1,22-10.6,32.9-21.4,37-8.5,3.2-16.8.5-24-2a57.6,57.6,0,0,1-16.6-8.8,19.864,19.864,0,0,1-2.7-2.2c-.4-.3-.7-.6-1.1-.9l-.3-.3c-.6-.6-1.2-1.1-1.8-1.7-1.5,2.5-2.9,4.5-4.9,4.6-.8,0-2.6-.1-3.2-1.3a2.009,2.009,0,0,1-.1-1.5,28.065,28.065,0,0,1,2.9-6.4c-1.3,2-2.4,3.6-3.3,4.9-2.3,3.2-3.2,4-4.4,4.2a3.182,3.182,0,0,1-2.7-.7,3.466,3.466,0,0,1-1-2.4v-.4a1.612,1.612,0,0,1-.7.4c-1.8,1.1-3.8,1.2-5,.3a3.741,3.741,0,0,1-1.4-2.2c-.3-1.3,0-2.8,2.1-6.1a29.553,29.553,0,0,1,6.2-6.9c-5.2,3.2-7.9,6.4-9.4,8.9-.6,1-1.8,3-3.7,3.3a3.842,3.842,0,0,1-3.7-1.6C217.6,288.4,224.1,281.4,226.7,278.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17974",
    "data-name": "Path 17974",
    d: "M274.1,308.9a59.412,59.412,0,0,1-16.7-8.8c-.9-.7-1.8-1.4-2.7-2.2-.4-.3-.7-.6-1.1-.9l-.3-.3c-.4-.4-.9-.8-1.4-1.3-1.5,2.4-2.9,4.2-5,4.4-.9.1-2.9-.2-3.7-1.5a3.435,3.435,0,0,1-.2-1.9,2.544,2.544,0,0,1,.2-.7c-2.1,2.9-3,3.7-4.4,3.9a3.706,3.706,0,0,1-3.1-.8,3.524,3.524,0,0,1-1.1-2.3c-2,1.1-4.1,1.2-5.5.2a4.723,4.723,0,0,1-1.6-2.4c-.3-1.4-.1-3,2.1-6.5a13.676,13.676,0,0,1,1.8-2.4,24.263,24.263,0,0,0-4.2,5l-.1.2c-.7,1.1-1.9,3-3.9,3.3a4.4,4.4,0,0,1-4.2-1.8c-2.1-3.6,4.4-10.7,7.2-13.7l.4.3-.4-.3c2.5-2.7,4.4-4.8,7.8-6.8s9.6-5.7,16.6-3.6h.2l.2.1a16.153,16.153,0,0,1,3.5,1.7l33.2,16c5.8-10.9,19.5-34.9,27.9-32.5,2.4.7,4.4,3.6,4.6,3.9,3.6,5.4,1.2,12.9.1,16.5-7.1,22.1-10.7,33.2-21.7,37.3a23.334,23.334,0,0,1-8.4,1.5C284.5,312.3,279.1,310.5,274.1,308.9Zm14.3-22.4a.481.481,0,0,1-.6.2l-33.6-16.2a15.046,15.046,0,0,0-3.4-1.6h-.2c-6.6-2.1-12.7,1.5-15.9,3.5-3.3,1.9-5.2,4-7.6,6.6h0c-2.2,2.4-8.8,9.6-7.1,12.5a3.592,3.592,0,0,0,3.2,1.4c1.6-.2,2.6-1.9,3.2-2.9l.1-.2a28.9,28.9,0,0,1,9.6-9c.2-.1.5-.1.6.1a.616.616,0,0,1-.1.7,30.1,30.1,0,0,0-6.1,6.8c-2.1,3.2-2.3,4.6-2,5.7a3.646,3.646,0,0,0,1.2,1.9,4.143,4.143,0,0,0,4.5-.3c.2-.1.4-.3.6-.4a.446.446,0,0,1,.5,0,.365.365,0,0,1,.2.5v.3a2.94,2.94,0,0,0,.8,2.1,2.836,2.836,0,0,0,2.3.6c.9-.1,1.7-.7,4.1-4,1.1-1.6,2.2-3.2,3.3-4.9a.515.515,0,1,1,.9.5,27.693,27.693,0,0,0-2.9,6.2,1.708,1.708,0,0,0,.1,1.2,3.092,3.092,0,0,0,2.7,1c1.8-.1,3.1-2.1,4.6-4.4a.52.52,0,0,1,.4-.2.6.6,0,0,1,.4.1c.6.6,1.2,1.1,1.8,1.6l.3.3a10.627,10.627,0,0,0,1.1.9c.9.8,1.8,1.5,2.7,2.2a60.248,60.248,0,0,0,16.4,8.7c7.2,2.4,15.3,5.1,23.7,2,10.6-4,14.1-15,21.2-36.7,1.7-5.2,3-11.2.1-15.6-.1-.1-1.9-2.9-4.1-3.5a3.4,3.4,0,0,0-1-.1C306.1,253.9,292.5,278.7,288.4,286.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1732",
    "data-name": "Group 1732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 89.9,
    height: 6.6,
    transform: "translate(257.203 345.887) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17975",
    "data-name": "Path 17975",
    d: "M166.8,345.9v-6.6a.472.472,0,0,1,.5-.5h89.9a.472.472,0,0,1,.5.5v6.6a.472.472,0,0,1-.5.5H167.3A.472.472,0,0,1,166.8,345.9Zm89.9-6.1H167.8v5.6h88.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 6.3,
    height: 217.4,
    transform: "translate(260.434 533.277) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17976",
    "data-name": "Path 17976",
    d: "M253.7,533.3V315.9a.472.472,0,0,1,.5-.5h6.3a.472.472,0,0,1,.5.5V533.3a.472.472,0,0,1-.5.5h-6.3A.472.472,0,0,1,253.7,533.3ZM260,316.4h-5.3V532.9H260Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 6.3,
    height: 217.4,
    transform: "translate(172.273 533.277) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17977",
    "data-name": "Path 17977",
    d: "M165.5,533.3V315.9a.472.472,0,0,1,.5-.5h6.3a.472.472,0,0,1,.5.5V533.3a.472.472,0,0,1-.5.5H166A.472.472,0,0,1,165.5,533.3Zm6.3-216.9h-5.3V532.9h5.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    "data-name": "Group 1738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 109.4,
    height: 8.3,
    transform: "translate(268.67 318.105) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17978",
    "data-name": "Path 17978",
    d: "M158.8,318.1v-8.3a.472.472,0,0,1,.5-.5H268.7a.472.472,0,0,1,.5.5v8.3a.472.472,0,0,1-.5.5H159.3A.536.536,0,0,1,158.8,318.1Zm109.4-7.9H159.8v7.4H268.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17979",
    "data-name": "Path 17979",
    d: "M257,305.5l-1.3-3.6h-5.3l-.7,3.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17980",
    "data-name": "Path 17980",
    d: "M250.5,305.6l-1.2-3.7H244l-.8,3.9Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17981",
    "data-name": "Path 17981",
    d: "M243.8,305.6l-1.3-3.7h-5.3l-.8,3.9Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17982",
    "data-name": "Path 17982",
    d: "M237.2,305.6l-1.3-3.7h-5.3l-.8,3.9Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17983",
    "data-name": "Path 17983",
    d: "M162.4,270.8l14.8,34.5c.1.2.2.3.4.3H231c.3,0,.5-.4.3-.8l-16.6-34.5c-.1-.2-.2-.2-.3-.2H162.8C162.5,270,162.3,270.4,162.4,270.8Z",
    fill: "#19647e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17984",
    "data-name": "Path 17984",
    d: "M162.4,270.8l14.8,34.5c.1.2.2.3.4.3H231c.3,0,.5-.4.3-.8l-16.6-34.5c-.1-.2-.2-.2-.3-.2H162.8C162.5,270,162.3,270.4,162.4,270.8Z",
    fill: "#19647e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 70,
    height: 76,
    transform: "translate(162 250)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABMCAYAAADQtcHiAAAACXBIWXMAAAsSAAALEgHS3X78AAAB10lEQVR4nO2cW24CMQxFB8R318DGujo2xhq6gVZQaCHEwySx48f1kfhF0dWxM3E0s3jjePr6vvykl73zkkstjPPnh9j6D1J/zMEMMyhMGtMSiJQ1pozRNKRE3RiOMCSsUTPGkh01pgdjPZA7U0ppRhjc5SRqjBc7aogYoxUIpzWsxng2pGQ4YWthcFnTbUwkO2o0p+shEA5rNhkT3Y4aq8EgBnKnqlyEQEbL6c8YZDtq7CIHMmLNnncpcQgdzEg1pDEEe8lJu2fCG9NbTtdg0ppXIHpMjzXZfAmeSij6029Ly0hjCJ6CySb8D5QxLa3iJZi05he4HrPVmmy+BGTZoG/daQzBamrI1qQxBKvBIG/d0MastYq3waBaA99jKGvgg6HYXCZoW3caQ7A5GLQmnMbcKFtFUzBI1qQxDzxak8EQdJUGwtadxhB0N9Po1qQxBEPbb2Rr0pgKl+Yb7iWLXsqHV9PvXc+AepqHDebd8Ybl7OOlnFrOehDG9Bx+2U7LFq0ZmQaEM4ZrNMI6X9G0xtV71zOA+BpIC9LTRPY/lyynmaNVF8ZozJpNf8JAc/huzhgrNxFii2i1xtrVjLoxVu+qVILxcHEnusCynDzdZE4xxt3V7rIsP6ZcsMWmjddCAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17986",
    "data-name": "Path 17986",
    d: "M162.4,270.8l14.8,34.5c.1.2.2.3.4.3H231c.3,0,.5-.4.3-.8l-16.6-34.5c-.1-.2-.2-.2-.3-.2H162.8C162.5,270,162.3,270.4,162.4,270.8Z",
    fill: "#19647e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17987",
    "data-name": "Path 17987",
    d: "M177.6,306H231a.842.842,0,0,0,.7-.4,1.376,1.376,0,0,0,.1-1.1L215.2,270a1.02,1.02,0,0,0-.8-.5H177.3a.5.5,0,0,0,0,1h37L230.9,305v.1H177.7L173,294.2c-.1-.2-.4-.4-.6-.3s-.4.4-.3.6l4.7,10.9A.938.938,0,0,0,177.6,306Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 82.2,
    height: 5.2,
    transform: "translate(177.3 304.8)",
    fill: "#19647e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    "data-name": "Group 1766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17988",
    "data-name": "Path 17988",
    d: "M176.8,310v-5.2a.472.472,0,0,1,.5-.5h82.2a.472.472,0,0,1,.5.5V310a.472.472,0,0,1-.5.5H177.3A.472.472,0,0,1,176.8,310Zm82.3-4.8H177.8v4.3h81.3Z",
    fill: "#060e12"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1771",
    "data-name": "Group 1771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17989",
    "data-name": "Path 17989",
    d: "M287.3,279.2s18.8-29.2,26.2-27.9,10.6,6.5,10.6,12.6-9.5,34.4-9.5,34.4S296.2,292.6,287.3,279.2Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17990",
    "data-name": "Path 17990",
    d: "M287.3,279.2s18.8-29.2,26.2-27.9,10.6,6.5,10.6,12.6-9.5,34.4-9.5,34.4S296.2,292.6,287.3,279.2Z",
    fill: "#61703f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 41,
    height: 82,
    transform: "translate(284 249)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAABSCAYAAADJhf30AAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVRoge3bzQ1FQBRA4UtdqlCCwpSgCn09sZD4WwjncSc539LGMWMxEyb2+rb5HS5+rHorshvGw72uei3yiTpb0BkjKUZSjKQYSTGSUkTkZoGRcXERTjcofeS8WHYkKUZSjKQYSTGSYiTFSIqRlLIis27CwukGpY5cvlg4khQjKUZSjKQYSTGSYiTFSEo5kZk3YeF0g9JGrn8bcyQpRlKMpBhJMZJiJMVIipGUOvv+Jpxu0K3jJ/9+RfbHYm6fkaGtH3wTGRET4gkfH7UylE4AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17992",
    "data-name": "Path 17992",
    d: "M287.3,279.2s18.8-29.2,26.2-27.9,10.6,6.5,10.6,12.6-9.5,34.4-9.5,34.4S296.2,292.6,287.3,279.2Z",
    fill: "#61703f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17993",
    "data-name": "Path 17993",
    d: "M286.1,229.2a7.457,7.457,0,0,0,1.2.7,5.637,5.637,0,0,0,1.2.4.367.367,0,0,1,.3.1h2.5a2.092,2.092,0,0,1-.6.4c-.1.1-.2.1-.4.1-.1,0-.1,0-.2.1h-.2c-.1,0-.3.1-.4.1h-.8a.6.6,0,0,1-.4-.1,3.694,3.694,0,0,1-1.4-.7A1.879,1.879,0,0,1,286.1,229.2Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1780",
    "data-name": "Group 1780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17994",
    "data-name": "Path 17994",
    d: "M298.7,223.5h0a.536.536,0,0,0,.5-.5,6.356,6.356,0,0,0-4.6-4.4c-.3,0-.5.1-.5.4s.1.5.4.5a5.365,5.365,0,0,1,3.8,3.5A.458.458,0,0,0,298.7,223.5Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17995",
    "data-name": "Path 17995",
    d: "M291.6,218.2a.367.367,0,0,0,.3-.1.616.616,0,0,0,.1-.7,4.3,4.3,0,0,0-3.8-1.3c-.3,0-.4.3-.4.5,0,.3.3.4.5.4a3.525,3.525,0,0,1,3,1C291.4,218.2,291.5,218.2,291.6,218.2Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17996",
    "data-name": "Path 17996",
    d: "M288.8,228.2a.758.758,0,0,0,.4-.2.494.494,0,0,0-.1-.7,5.127,5.127,0,0,1-1.7-2,5.649,5.649,0,0,1,1.5-1.1,20.058,20.058,0,0,0,3.1-2.4.495.495,0,0,0-.7-.7,26.838,26.838,0,0,1-3,2.3,5.848,5.848,0,0,0-1.8,1.5c-.5.9,1,2.4,2,3.2A.367.367,0,0,0,288.8,228.2Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17997",
    "data-name": "Path 17997",
    d: "M303.5,229.8h0a2.758,2.758,0,0,0,2.6-2.6,2.044,2.044,0,0,0-1.3-2.1.474.474,0,0,0-.3.9,1.007,1.007,0,0,1,.5,1.1,1.86,1.86,0,0,1-1.7,1.7c-.3,0-.4.3-.4.6A.675.675,0,0,0,303.5,229.8Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1784",
    "data-name": "Group 1784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17998",
    "data-name": "Path 17998",
    d: "M317,221.3a6.625,6.625,0,0,0,3.6-1.1,4.9,4.9,0,0,0,2.4-4.1.5.5,0,1,0-1,0,4.277,4.277,0,0,1-2,3.3,5.753,5.753,0,0,1-5.7.4.447.447,0,1,0-.4.8A7.3,7.3,0,0,0,317,221.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1785",
    "data-name": "Group 1785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17999",
    "data-name": "Path 17999",
    d: "M304.6,233.5c3.4,0,8.2-4,8.3-7.9a.5.5,0,0,0-1,0c-.1,3.4-4.4,7-7.4,7a.472.472,0,0,0-.5.5A.675.675,0,0,0,304.6,233.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18000",
    "data-name": "Path 18000",
    d: "M314.6,298.7a.55.55,0,0,0,.5-.3c.1-.2,5.3-15.8,8-26.2a.474.474,0,0,0-.9-.3c-2.4,9.4-6.9,23-7.8,25.7-2.8-1-18.4-6.7-26.4-18.5,1.4-2.2,11.3-17.1,19-24a.495.495,0,0,0-.7-.7c-8.4,7.5-19.3,24.3-19.4,24.5a.446.446,0,0,0,0,.5c8.9,13.4,27.4,19.2,27.6,19.3Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18001",
    "data-name": "Path 18001",
    d: "M235.1,296.1a.51.51,0,0,0,.5-.4c1.6-6.1,7.3-10.9,7.3-11a.5.5,0,0,0-.6-.8c-.2.2-6,5-7.7,11.5a.486.486,0,0,0,.3.6C235.1,296,235.1,296.1,235.1,296.1Z",
    fill: "#060e12"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpoloipo);
export default __webpack_public_path__ + "static/media/upoloipo.91c4d572abedb08d3d1a9b12f46b12e2.svg";
export { ForwardRef as ReactComponent };